module.exports = __webpack_public_path__ + "static/media/russo.4a892ec1.png";